export enum SwMsgTypes {
  SkipWaiting = 'SKIP_WAITING',
  SkipWaitingDone = 'SKIP_WAITING_DONE',
  RequestVersion = 'REQUEST_VERSION',
  ResponseVersion = 'RESPONSE_VERSION',
}
